import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

const footerColumns = [
  {
    title: "Categories",
    links: categories.slice(0, 7).map((cat) => ({
      label: cat.name,
      url: cat.url,
      external: true,
    })),
  },
  {
    title: "More Categories",
    links: categories.slice(7).map((cat) => ({
      label: cat.name,
      url: cat.url,
      external: true,
    })),
  },
  {
    title: "SEO Guides",
    links: articles.slice(0, 6).map((article) => ({
      label: article.title.length > 28 ? article.title.slice(0, 28) + "..." : article.title,
      url: `/${article.slug}`,
      external: false,
    })),
  },
  {
    title: "Quick Links",
    links: [
      { label: "Home", url: "/", external: false },
      { label: "Shopping Guide", url: "https://kaspreadsheet.com/", external: true },
      { label: "acbuy spreadsheet", url: "https://kaspreadsheet.com/", external: true },
      { label: "buy it now", url: "https://kaspreadsheet.com/", external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-14">
          {footerColumns.map((col, idx) => (
            <div key={idx}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">
                {col.title}
              </h4>
              <div className="w-8 h-px bg-background-300 mb-4"></div>
              <ul className="space-y-2.5">
                {col.links.map((link, linkIdx) => (
                  <li key={linkIdx}>
                    {link.external ? (
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.url}
                        className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between py-8 border-t border-background-200/60 gap-6">
          <div>
            <div className="flex items-baseline gap-1 mb-1">
              <span className="font-heading text-4xl font-bold text-foreground-900">ACBuy</span>
              <span className="font-heading text-4xl font-light text-foreground-400">Spreadsheet</span>
            </div>
            <div className="w-10 h-0.5 bg-foreground-900 mb-2"></div>
            <p className="text-xs text-foreground-500">Bridge page for KAS sourcing</p>
          </div>
          <div className="flex flex-col items-start sm:items-end gap-3">
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer" aria-label="TikTok">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer" aria-label="Twitter X">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
            <p className="text-xs text-foreground-400">&copy; 2026 ACBuy Spreadsheet. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}